// import { useEffect, useState } from 'react';
import { Percomatic } from '@biggby-coffee/percomatic-typescript';
import { useCallback } from 'react';
import { useSetRecoilState } from 'recoil';

import { sessionCartState } from '../../atoms';
import { getCartFromTrans } from '../../utils/getCartFromTrans';

import {
	setCartTotalPlusTax,
	setBalanceDue
} from '../../../domains/Checkout/slice';
import { useAppDispatch } from '../../../reduxstore/hooks';

export const useUpdateSessionCart = (
	onComplete?: () => void
): ((state: Percomatic.State) => void) => {
	const setSessionCart = useSetRecoilState(sessionCartState);

	const dispatch = useAppDispatch();

	return useCallback(
		(state: Percomatic.State) => {
			const { currentTrans } =
				state.ui.homeScreenHandler.orderScreenHandler;

			if (currentTrans) {
				setSessionCart(getCartFromTrans(currentTrans));
			}

			dispatch(setCartTotalPlusTax(currentTrans?.total));
			dispatch(setBalanceDue(currentTrans?.total));

			onComplete && onComplete();
		},
		[dispatch, onComplete, setSessionCart]
	);
};
